import React from 'react';
import FileSelect from '../../fileSelect';

const _FileSelect = () => <FileSelect withDownloader />;

export default _FileSelect;
